__webpack_require__.p = "/signal-custom-observe-element/referrals-hub/";